module.exports = __webpack_public_path__ + "static/img/蒙版组 12.9a07501.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inAndOut/register/images/蒙版组 12.png
// module id = 6pQA
// module chunks = 0